import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="pipeline-source-fields"
export default class extends Controller {
  static values = { url: String }

  reload(event) {
    const pipelineId = event.target.value
    get(this.urlValue, {
      query: { pipeline_id: pipelineId },
      responseKind: "turbo-stream"
    })
  }
}
